/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentPolo202,
  PutApiV1CourseregistrationEnrollmentPolo400,
  PutApiV1CourseregistrationEnrollmentPolo401,
  PutApiV1CourseregistrationEnrollmentPolo500,
  PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
  PutApiV1CourseregistrationEnrollmentPoloQueryParams,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentPolo.ts";

export const putApiV1CourseregistrationEnrollmentPoloQueryParamsSchema = z
  .object({
    courseRegistrationId: z.optional(z.coerce.number().int()),
    poloId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPoloQueryParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentPolo202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPolo202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentPolo400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPolo400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentPolo401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPolo401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentPolo500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPolo500>;

export const putApiV1CourseregistrationEnrollmentPoloMutationResponseSchema =
  z.lazy(
    () => putApiV1CourseregistrationEnrollmentPolo202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentPoloMutationResponse>;
